// extracted by mini-css-extract-plugin
export default {"button":"SizeTable_button__aPQoE","sizeTable":"SizeTable_sizeTable__IxnrP","image":"SizeTable_image__sSGc_","wrapper":"SizeTable_wrapper__VO9n9","title":"SizeTable_title__f3SWq"};